<div class="overlay" *ngIf="isLoading | async">
  <mat-spinner color="primary"></mat-spinner>
</div>